// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3vFHA","boxTitle":"Qualiphy_boxTitle__24SRD","box":"Qualiphy_box__24hqL","toggleWrap":"Qualiphy_toggleWrap__6TtBR"};